import { Component } from 'react';
import Modal from '../modal';
import cx from 'classnames';
import styles from '../../styles/paymentSchedule/schedulePayment.scss';
import { Router } from '../../configs/routes';
import { stringify } from 'query-string';
import { trackAction } from '../../utils/trackActions';

interface Props {
  dismissModal: () => void;
  investmentType: string;
  url: any;
}

interface State {
  isMandateSelected: boolean;
}

class ScheduleMethodModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isMandateSelected: true,
    };
  }

  private handleBtnClick = () => {
    const { isMandateSelected } = this.state;
    const { investmentType, url } = this.props;
    const { query } = url;
    const { detailsSlug, id, ...queryObj } = query;
    queryObj.schedulePayment =
      investmentType === 'SIP_MF' ? 'sipPayment' : 'lumpsumPayment';
    queryObj.paymentMode = isMandateSelected ? 'mandate' : 'link';
    trackAction(
      'schedule-method-selection',
      'schedule-payment-flow',
      isMandateSelected ? 'set-up-mandate' : 'get-payment-link'
    );
    Router.pushRoute(`${location.pathname}?${stringify(queryObj)}`);
  };

  private handleScheduleMethodSelection = (e: any) => {
    const { id } = e.currentTarget;
    this.setState({
      isMandateSelected: id === 'mandate',
    });
  };

  private goBack = () => {
    Router.pushRoute(`${location.pathname}?detailsSlug=payment`);
  };

  public render() {
    const { dismissModal } = this.props;
    const { isMandateSelected } = this.state;

    return (
      <Modal
        title={'Schedule your SIP payment'}
        maxWidth={'650px'}
        fullScreen
        onDismiss={dismissModal}
      >
        <div className={cx(styles['back'])} onClick={this.goBack}>
          &#8592;
        </div>

        <section className="mb20">
          <div className="mb15 px15 font--bold">Choose a scheduling method</div>
          <div className="row">
            <div
              id="mandate"
              onClick={this.handleScheduleMethodSelection}
              className={cx('columns medium-6 mb10')}
            >
              <div
                className={cx(styles['method'], 'p15', {
                  [styles['selected']]: isMandateSelected,
                })}
              >
                <div className="mb10 bold text--normal">
                  Set up a Mandate
                  <span className={cx(styles['recommended'], 'text--sm')}>
                    RECOMMENDED
                  </span>
                </div>
                <div className="line-height text--sm mb10">
                  A mandate is an instruction for your bank to schedule/automate
                  your payments.
                </div>
                <ul className={cx(styles['list'])}>
                  <li>One-time setup</li>
                  <li>Setting up takes only a few minutes</li>
                  <li>Easy and hassle free process</li>
                </ul>
              </div>
            </div>
            <div
              id="email"
              onClick={this.handleScheduleMethodSelection}
              className={cx('columns medium-6 mb10')}
            >
              <div
                className={cx(styles['method'], 'p15', {
                  [styles['selected']]: !isMandateSelected,
                })}
              >
                <div className="mb10 bold text--normal">
                  Get Payment links via email
                </div>
                <div className="line-height text--sm mb10">
                  Get timely payment links delivered to your email as per
                  selected schedule
                </div>
                <ul className={cx(styles['list'])}>
                  <li>Each payment has to be done manually</li>
                  <li>Payment links have limited validity</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="center mb20">
          <button
            className="btn-green-solid pl30 pr30 text--normal"
            onClick={this.handleBtnClick}
          >
            {isMandateSelected
              ? 'PROCEED TO SET UP MANDATE'
              : 'PROCEED WITH PAYMENT LINKS'}
          </button>
        </div>
      </Modal>
    );
  }
}

export default ScheduleMethodModal;



// WEBPACK FOOTER //
// ./components/paymentSchedule/scheduleMethodModal.tsx